import { useState } from "react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "../ui/alert-dialog";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";

/** Typed confirmation for backend-enforced, audited agent actions (enable/disable agent, invalidate memory). */
export const ConfirmAgentAction = ({ action, busy, onCancel, onConfirm }) => {
  const [typed, setTyped] = useState("");
  const [note, setNote] = useState("");
  const [number, setNumber] = useState(action?.numberValue ?? "");
  if (!action) return null;
  const numberOk = !action.withNumber || (number !== "" && Number.isInteger(Number(number)) && Number(number) >= 0);
  const ok = typed.trim() === action.confirmValue && numberOk;
  return (
    <AlertDialog open onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent className="max-w-md" data-testid="agent-confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle data-testid="agent-confirm-title">{action.title}</AlertDialogTitle>
          <AlertDialogDescription data-testid="agent-confirm-description">{action.description}</AlertDialogDescription>
        </AlertDialogHeader>
        <div className="space-y-3">
          {action.withNumber && <div className="space-y-1"><Label htmlFor="agent-number" className="text-xs">{action.withNumber}</Label><Input id="agent-number" type="number" min={0} max={10000} value={number} onChange={(e) => setNumber(e.target.value)} className="font-mono-tech" data-testid="agent-confirm-number" /></div>}
          {action.withNote && <div className="space-y-1"><Label htmlFor="agent-note" className="text-xs">Note (audited)</Label><Textarea id="agent-note" rows={2} maxLength={500} value={note} onChange={(e) => setNote(e.target.value)} data-testid="agent-confirm-note" /></div>}
          <div className="space-y-1">
            <Label htmlFor="agent-confirm" className="text-xs">Type <span className="font-mono-tech font-semibold">{action.confirmValue}</span> to confirm</Label>
            <Input id="agent-confirm" value={typed} onChange={(e) => setTyped(e.target.value)} placeholder={action.confirmValue} className="font-mono-tech" data-testid="agent-confirm-input" />
          </div>
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="agent-confirm-cancel">Cancel</AlertDialogCancel>
          <AlertDialogAction disabled={!ok || busy} onClick={(e) => { e.preventDefault(); onConfirm({ note, number: action.withNumber ? Number(number) : undefined }); }} className={action.destructive ? "bg-destructive text-destructive-foreground hover:bg-destructive/90" : ""} data-testid="agent-confirm-submit">{busy ? "Working…" : action.cta}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
